import { useSingleton } from '@bydesign-ui/hooks';
import { getElementScroll } from '@bydesign-ui/hooks';
import { useScroll } from '@bydesign-ui/hooks';
import { useRef } from 'react';
import { Anchor } from '../../../models/anchor';
export function useCreateAnchor(options) {
  var anchor = useSingleton(function () {
    return new Anchor();
  });
  var scrollInfo = useRef(getElementScroll(anchor.getContainer()));
  anchor.updateOptions(options);
  useScroll(function () {
    return !anchor.getScrolling();
  }, function () {
    var newInfo = getElementScroll(anchor.getContainer());

    if (scrollInfo.current.scrollTop !== newInfo.scrollTop) {
      scrollInfo.current = newInfo;
      anchor.updateScrollTop();
    }
  });
  return anchor;
}